import React from 'react';

const Hint = ({ question }) => {
  return (
    <p>{question.hint}</p>
  );
};

export default Hint;